var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImprimir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "imprimir",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1499",
    "data-name": "Caminho 1499",
    d: "M21.5,18h-3a.5.5,0,0,1,0-1h3A1.5,1.5,0,0,0,23,15.5v-7A1.5,1.5,0,0,0,21.5,7H2.5A1.5,1.5,0,0,0,1,8.5v7A1.5,1.5,0,0,0,2.5,17h3a.5.5,0,0,1,0,1h-3A2.5,2.5,0,0,1,0,15.5v-7A2.5,2.5,0,0,1,2.5,6h19A2.5,2.5,0,0,1,24,8.5v7A2.5,2.5,0,0,1,21.5,18Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1500",
    "data-name": "Caminho 1500",
    d: "M14.5,21h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1501",
    "data-name": "Caminho 1501",
    d: "M14.5,19h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1502",
    "data-name": "Caminho 1502",
    d: "M10.5,17h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1503",
    "data-name": "Caminho 1503",
    d: "M18.5,7a.5.5,0,0,1-.5-.5v-4A1.5,1.5,0,0,0,16.5,1h-9A1.5,1.5,0,0,0,6,2.5v4a.5.5,0,0,1-1,0v-4A2.5,2.5,0,0,1,7.5,0h9A2.5,2.5,0,0,1,19,2.5v4A.5.5,0,0,1,18.5,7Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1504",
    "data-name": "Caminho 1504",
    d: "M16.5,24h-9A2.5,2.5,0,0,1,5,21.5v-8a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v8A2.5,2.5,0,0,1,16.5,24ZM6,14v7.5A1.5,1.5,0,0,0,7.5,23h9A1.5,1.5,0,0,0,18,21.5V14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprimir);
export default __webpack_public_path__ + "static/media/imprimir.a977eb8551c24942f56155c0a507c300.svg";
export { ForwardRef as ReactComponent };